export default __webpack_public_path__ + "static/media/diamond-clarity-3@2x.93bda93e.png";